/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components, getter-return */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { classNameBindings } from '@ember-decorators/component';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import Relationship from '@linc-technologies/linced-common/enums/medical-relationship';
import moment from 'moment';

@classNameBindings('contact.currentState.isDirty:md-dirty')
export default class MedicalContactCard extends Component {
  @service
  session;

  Relationship = Relationship;
  Jurisdiction = Jurisdiction;

  // medicalPersonRecord is the medical contact's person record. The
  // MedicalContactManager loads it before it shows the card.
  @alias('contact.medicalPerson')
  medicalPersonRecord;

  @alias('session.school.jurisdiction')
  jurisdiction;

  @computed('contact.externalId')
  get canEditRemove() {
    return isEmpty(this.contact.get('externalId'));
  }

  @computed('contact.{startDate,endDate}')
  get dateRange() {
    if (isEmpty(this.contact.startDate) && isEmpty(this.contact.endDate)) {
      return '';
    }

    let dateRange = '';
    let { startDate, endDate } = this.contact;
    let start = moment(startDate).format('DD/MM/YYYY');
    let end = moment(endDate).format('DD/MM/YYYY');
    switch (true) {
      case !isEmpty(startDate) && !isEmpty(endDate):
        dateRange = `${start} - ${end}`;
        break;

      case !isEmpty(startDate):
        dateRange = `From ${start}`;
        break;

      case !isEmpty(endDate):
        dateRange = `Until ${end}`;
        break;
    }
    return dateRange;
  }

  @computed('medicalPersonRecord.fields.[]', 'jurisdiction')
  get medicalAddress() {
    let record = this.medicalPersonRecord;
    if (!isEmpty(record)) {
      let fieldSuffix = 'core';
      let address1 = record.get(`fields.${fieldSuffix}:address1.valueString`);
      let address2 = record.get(`fields.${fieldSuffix}:address2.valueString`);
      let address3 = record.get(`fields.${fieldSuffix}:address3.valueString`);
      let address4 = record.get(`fields.${fieldSuffix}:address4.valueString`);
      let postcode = record.get(`fields.${fieldSuffix}:postcode.valueString`);
      let moreAddress = [address2, address3, address4]
        .filter((addr) => {
          return !isEmpty(addr);
        })
        .join(', ');
      if (isEmpty(address1) && isEmpty(moreAddress) && isEmpty(postcode)) {
        return;
      }
      return {
        address1,
        moreAddress,
        postcode,
      };
    }
  }

  @computed('medicalPersonRecord.fields.[]')
  get doctorTitle() {
    return this.medicalPersonRecord?.get(`fields.core:title.valueString`);
  }
}
